module.exports = {
          srcSet: __webpack_public_path__ + "df704bd3.jpg"+" 700w"+","+__webpack_public_path__ + "db0e7cbb.jpg"+" 985w",
          images:[ {path: __webpack_public_path__ + "df704bd3.jpg",width: 700,height: 554},{path: __webpack_public_path__ + "db0e7cbb.jpg",width: 985,height: 780}],
          src: __webpack_public_path__ + "df704bd3.jpg",
          toString:function(){return __webpack_public_path__ + "df704bd3.jpg"},
          
          width: 700,
          height: 554
        }